import React, { useCallback, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Form } from 'semantic-ui-react'
import { AddBtn } from '../../../commonComponents/AddBtn'
import { FormTitle } from '../../../commonComponents/FormTitle'
import List from '../../../commonComponents/List'
import AuthorizationDetails from '../partiesTab/authorizationDetails'
import { CustomLoader } from '../../../commonComponents/formComponents/loader'
import { saveMultipleTabsValue } from '../../api/saveNLdata'
import {
  createMultipleTabsInItem,
  deleteMultipleTabsInItem,
  updateMultipleLineData,
} from '../../actions'
import { TranslateContext } from '../TranslateContext'

const Authorization = (props) => {
  const dispatch = useDispatch()
  const { merchandiseId, declarationType, invoiceId, lineItemIndex } = props
  const key = 'authorization'
  const isFormEnabled = false
  const [isLoading, setisLoading] = useState(false)
  const authorizationList =
    useSelector(
      (state) => state.InvoicesReducer.lineItems[invoiceId][lineItemIndex]?.authorization
    ) || []
  const updateLoadingStatus = () => {
    setisLoading(false)
  }
  const createAuthorization = () => {
    setisLoading(true)

    dispatch(
      createMultipleTabsInItem(invoiceId, merchandiseId, declarationType, key, updateLoadingStatus)
    )
  }
  const deleteAuthorization = (id) => {
    setisLoading(true)

    dispatch(
      deleteMultipleTabsInItem(
        invoiceId,
        merchandiseId,
        declarationType,
        key,
        id,
        updateLoadingStatus
      )
    )
  }
  const updateAuthorization = (id, payload) => {
    let [fieldName, value] = Object.entries(payload)[0]
    dispatch(updateMultipleLineData(invoiceId, merchandiseId, id, key, fieldName, value))
  }
  const saveAuthorization = (payload) => {
    saveMultipleTabsValue(invoiceId, merchandiseId, declarationType, key, payload)
  }

  const renderItem = useCallback(
    (item) => {
      return (
        <AuthorizationDetails
          key={item.infoId}
          item={item}
          isFormEnabled={isFormEnabled}
          updateData={updateAuthorization}
          deleteData={deleteAuthorization}
          saveData={saveAuthorization}
        />
      )
    },
    [isFormEnabled, updateAuthorization, deleteAuthorization]
  )

  const translate = React.useContext(TranslateContext).translate
  return (
    <Form.Group className='float-container'>
      <FormTitle title={translate("AUTHORIZATION", {ns:["default", "lineItem", "parties"]}) }></FormTitle>
      <List renderItem={renderItem} dataSource={authorizationList} />

      {isLoading && <CustomLoader />}
      {authorizationList?.length < 9 && (
        <AddBtn
          disabled={isFormEnabled}
          onClick={createAuthorization}
          text={translate("ADD_AUTH", {ns:["default", "lineItem"]})}
        ></AddBtn>
      )}
    </Form.Group>
  )
}

export default React.memo(Authorization)
